import { Divider, Icon, Pagination } from '@zillow/constellation-10';
import {
    IconChevronLeftFilled,
    IconChevronRightFilled,
} from '@zillow/constellation-icons';
import React from 'react';

import { buildPaginatedLink } from './buildPaginatedLink';

interface PostsPaginationProps {
    page: number;
    pages: number;
    baseLink: string;
    query?: Record<string, string>;
    incrementPaginationLinks?: boolean;
}

export default function PostsPagination({
    page,
    pages,
    baseLink,
    query,
    incrementPaginationLinks,
}: PostsPaginationProps) {
    if (pages <= 1) {
        return null;
    }

    const pageOffset = incrementPaginationLinks ? 1 : 0;
    const currentPageIndex = page - 1;

    const prevHref =
        currentPageIndex === 0
            ? '#'
            : buildPaginatedLink({
                  baseLink,
                  query,
                  page: currentPageIndex - 1 + pageOffset,
              });

    const nextHref =
        currentPageIndex === pages - 1
            ? '#'
            : buildPaginatedLink({
                  baseLink,
                  query,
                  page: currentPageIndex + 1 + pageOffset,
              });

    return (
        <>
            <Divider css={{ marginBlock: 'loose' }} />
            <Pagination.Root
                currentPageIndex={currentPageIndex}
                totalPages={pages}
            >
                <Pagination.List>
                    <Pagination.Item>
                        <Pagination.PreviousButton
                            title="Previous page"
                            asChild
                            onClick={undefined}
                        >
                            <a href={prevHref} rel="prev">
                                <Icon>
                                    <IconChevronLeftFilled />
                                </Icon>
                            </a>
                        </Pagination.PreviousButton>
                    </Pagination.Item>
                    {/* Mobile: auto-shown when showNumberButtons=false, auto-hidden when true */}
                    <Pagination.Readout />
                    {/* Desktop: auto-hidden when showNumberButtons=false, auto-shown when true */}
                    <Pagination.PageItems
                        renderItem={({ key, buttonProps }) => {
                            const rawIndex = parseInt(
                                String(key).replace('page-', ''),
                                10
                            );
                            const pageIndex =
                                key === 'selectedPageButton' || isNaN(rawIndex)
                                    ? currentPageIndex
                                    : rawIndex;
                            return (
                                <Pagination.Item key={key}>
                                    <Pagination.PageButton
                                        {...buttonProps}
                                        asChild
                                        onClick={undefined}
                                    >
                                        <a
                                            href={buildPaginatedLink({
                                                baseLink,
                                                query,
                                                page: pageIndex + pageOffset,
                                            })}
                                        >
                                            {buttonProps.children}
                                        </a>
                                    </Pagination.PageButton>
                                </Pagination.Item>
                            );
                        }}
                    />
                    <Pagination.Item>
                        <Pagination.NextButton
                            title="Next page"
                            asChild
                            onClick={undefined}
                        >
                            <a href={nextHref} rel="next">
                                <Icon>
                                    <IconChevronRightFilled />
                                </Icon>
                            </a>
                        </Pagination.NextButton>
                    </Pagination.Item>
                </Pagination.List>
            </Pagination.Root>
        </>
    );
}
